export default function useInputReadOnly(formatList, inputReadOnly, multiple) {
  if (typeof formatList[0] === 'function' || multiple) {
    return true;
  }
  return inputReadOnly;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-picker/es/PickerInput/hooks/useInputReadOnly.js
// module id = 3721
// module chunks = 0